export default (that) => [
  {
    text: that.$l('btn_view_details') || '查看信息',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_edit_product') || '编辑产品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    allow: 'M',
    divided: true,
    disabled: false
  },
  {
    text: that.$l('btn_text_del') || '删除记录',
    icon: 'el-icon-delete',
    menuType: 'del',
    allow: 'D',
    disabled: ({ invSkuSetStatus }) => {
      return !['N', 'S'].includes(invSkuSetStatus)
    },
  },
  {
    text: that.$l('btn_availableSale') || '确认上架',
    icon: 'el-icon-circle-check',
    menuType: 'availableSale',
    divided: true,
    allow: 'P',
    disabled: ({ invSkuSetStatus }) => {
      return !['N', 'S'].includes(invSkuSetStatus)
    },
  },
  {
    text: that.$l('btn_view_stop') || '停用记录',
    icon: 'el-icon-circle-close',
    menuType: 'stop',
    divided: true,
    allow: 'S',
    disabled: ({ invSkuSetStatus }) => {
      return !['Y'].includes(invSkuSetStatus)
    },
  },
  // {
  //   text: that.$l('btn_sync_lc') || '推送良仓',
  //   icon: 'el-icon-refresh',
  //   menuType: 'syncLc',
  //   divided: true,
  //   allow: 'C',
  //   disabled: ({ invSkuSetStatus }) => {
  //     return !['Y'].includes(invSkuSetStatus)
  //   },
  // }
]
